export var BrandkitStatus;
(function (BrandkitStatus) {
    BrandkitStatus["UNKNOWN_STATUS"] = "UNKNOWN_STATUS";
    BrandkitStatus["DRAFT"] = "DRAFT";
    BrandkitStatus["PUBLISHED"] = "PUBLISHED";
    BrandkitStatus["FAILED"] = "FAILED";
})(BrandkitStatus || (BrandkitStatus = {}));
export var SortOrder;
(function (SortOrder) {
    SortOrder["ASC"] = "ASC";
    SortOrder["DESC"] = "DESC";
})(SortOrder || (SortOrder = {}));
export var WebhookIdentityType;
(function (WebhookIdentityType) {
    WebhookIdentityType["UNKNOWN"] = "UNKNOWN";
    WebhookIdentityType["ANONYMOUS_VISITOR"] = "ANONYMOUS_VISITOR";
    WebhookIdentityType["MEMBER"] = "MEMBER";
    WebhookIdentityType["WIX_USER"] = "WIX_USER";
    WebhookIdentityType["APP"] = "APP";
})(WebhookIdentityType || (WebhookIdentityType = {}));
//# sourceMappingURL=types.impl.js.map